import React from 'react';
import {LinearProgress, Stack} from '@mui/material';
import SystemMessageMarkdown from './SystemMessageMarkdown';

const SystemMessage = ({message}) => {
    return (
        <Stack width={'100%'} p={2}>
            {/* Meta section (separate component) */}
            {/*<SystemMessageMeta message={message}/>*/}

            {/* Markdown content (separate component, streams as it arrives). */}
            <SystemMessageMarkdown message={message}/>

            {message.status === 'pending' && <LinearProgress/>}

        </Stack>
    );
};

export default SystemMessage;
